var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "add-badge-custom-icon-modal",
        title: "Add badge custom icon",
        "body-bg-variant": "white",
        "body-class": "bg-white"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c("div", { staticClass: "ml-auto" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDeletePopup && _vm.picked != null,
                        expression: "showDeletePopup && picked != null"
                      }
                    ],
                    staticClass: "popover-danger",
                    attrs: { triggers: "click", placement: "top" }
                  },
                  [
                    _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                      _c("div", { staticClass: "px-5" }, [
                        _vm._v(
                          "Warning: Deleting this file will cause the badges that use it not to work anymore. Are you sure you want to remove this badge file?"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "px-5 d-flex justify-content-center" },
                      [
                        _c(
                          "b-button-toolbar",
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "success", size: "xs" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteItem(_vm.picked)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Yes\n                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "danger", size: "xs" },
                                on: {
                                  click: function($event) {
                                    _vm.showDeletePopup = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            No\n                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.tryDeleteItem(_vm.picked)
                    }
                  }
                },
                [_vm._v("Delete")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", disabled: _vm.picked == null },
                  on: {
                    click: function() {
                      _vm.pickIcon(_vm.picked)
                      _vm.showAddBadgeCustomIcon = false
                    }
                  }
                },
                [_vm._v("Save")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.showAddBadgeCustomIcon = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.showAddBadgeCustomIcon,
        callback: function($$v) {
          _vm.showAddBadgeCustomIcon = $$v
        },
        expression: "showAddBadgeCustomIcon"
      }
    },
    [
      _c(
        "div",
        { staticClass: "container-grid pl-3" },
        _vm._l(_vm.columns, function(column) {
          return _c(
            "div",
            { staticClass: "col-grid" },
            _vm._l(column, function(badgeIcon) {
              return _c("div", { staticClass: "item-container" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.picked,
                      expression: "picked"
                    }
                  ],
                  attrs: { type: "radio", id: "one" },
                  domProps: {
                    value: badgeIcon,
                    checked: _vm._q(_vm.picked, badgeIcon)
                  },
                  on: {
                    change: function($event) {
                      _vm.picked = badgeIcon
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { "max-width": "100px" },
                  attrs: { src: badgeIcon.downloadUrl }
                })
              ])
            }),
            0
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }